<!--
 * @Author: wangjx
 * @LastEditors: wangjx
 * @Date: 2022-03-01 09:35:13
 * @LastEditTime: 2022-03-11 15:07:55
 * @Description: file content
-->
<template >
  <div v-if="reload">
    <el-dialog
      v-dialogDrag
      :title="type === 'add' ? '新增规则' : '编辑规则'"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      :loading.sync="saving"
      top="5vh"
      width="70%"
      class="self-dialog-form"
    >
      <div>
        <div class="h-16 mb-4">
          <el-form
            ref="planForm"
            :model="solution"
            label-position="top"
            label-width="100px"
            :rules="rules"
            class="flex"
          >
            <el-form-item label="名称" prop="planName" class="w-48">
              <el-input v-model="solution.planName" :maxlength="10"></el-input>
            </el-form-item>

            <el-form-item label="业务对象" prop="structCode" class="w-48 pl-3">
              <el-select
                v-model="solution.structCode"
                class="w-full"
                placeholder="请选择业务对象"
                :disabled="type !== 'add'"
                @change="changeStruct"
                @visible-change="structVisibleChange"
              >
                <el-option
                  v-for="item in metadata"
                  :key="item.structCode"
                  :label="item.structName"
                  :value="item.structCode"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="表达式规则" class="w-48 pl-5">
              <el-switch v-model="customRules" :disabled="type !== 'add'"></el-switch>
            </el-form-item>
          </el-form>

          <!-- <el-select
            v-model="selectedStructCode"
            class="w-48 pt-3 pb-3"
            placeholder="请选择业务对象"
            @change="changeStruct"
          >
            <el-option
              v-for="item in metadata"
              :key="item.structCode"
              :label="item.structName"
              :value="item.structCode"
            />
          </el-select> -->
        </div>
      </div>
      <div v-if="!customRules">
        <!-- <el-form ref="tableForm" :model="tableFormParam"> -->
        <general-table
          code="DataMeta"
          :columns="tableHeaders"
          :data="tableFormParam.tableData"
          search-mode=""
          :no-pagination="true"
          :hide-oper-button="true"
          :operable-width="100"
        >
          <!-- 字段 -->
          <template #code="{ item }">
            <!-- <el-form-item
                :prop="'tableData[' + 0 + '].field'"
                :rules="{
                  required: true,
                  message: ' ',
                  trigger: 'blur'
                }"
              > -->
            <el-select
              v-model="item.field"
              class="w-full"
              placeholder="请选字段"
              @change="
                value => {
                  changeCodeSource(value, item);
                }
              "
            >
              <el-option
                v-for="item1 in selectedStruct.fields"
                :key="item1.fieldCode"
                :label="item1.fieldName"
                :value="item1.fieldCode"
              />
            </el-select>
            <!-- </el-form-item> -->
          </template>

          <!-- 条件 -->
          <template #operators="{ item }">
            <el-select
              v-model="item.operator"
              class="w-full"
              placeholder="请选择条件"
              :disabled="item.field === ''"
              @change="
                value => {
                  changeOperatorSource(value, item);
                }
              "
            >
              <el-option
                v-for="item1 in item.operatorArray"
                :key="item1.value"
                :label="item1.label"
                :value="item1.value"
              />
            </el-select>
          </template>

          <!-- 值 -->
          <template #value="{ item }">
            <!-- <el-button slot="reference">删除</el-button> -->
            <div v-if="item.selectField.refType === null || item.selectField.refType === ''">
              <el-time-picker
                v-if="item.selectField.fieldType === 'LOCALTIME'"
                v-model="item.value"
                :disabled="checkValueFormat(item) === 'null'"
                value-format="HH:mm:ss"
                placeholder="选择时间"
                :clearable="false"
              ></el-time-picker>
              <el-date-picker
                v-else-if="
                  item.selectField.fieldType === 'LOCALDATE'
                    || item.selectField.fieldType === 'LOCALDATETIME'
                "
                v-model="item.value"
                :type="item.selectField.fieldType === 'LOCALDATE' ? 'date' : 'datetime'"
                :disabled="checkValueFormat(item) === 'null'"
                :value-format="
                  item.selectField.fieldType === 'LOCALDATE' ? 'yyyy-MM-dd' : 'yyyy-MM-dd HH:mm:ss'
                "
                :clearable="false"
                placeholder="选择日期"
              ></el-date-picker>
              <el-input
                v-else
                v-model="item.value"
                :disabled="checkValueFormat(item) === 'null'"
                :placeholder="
                  checkValueFormat(item) === 'mulit' ? '支持数组， 使用\',\'隔开' : '规则值'
                "
              ></el-input>
            </div>

            <span
              v-else-if="item.selectField.refType === 'STRUCT'"
              :class="checkValueFormat(item) === 'null' ? 'cursor-not-allowed' : 'cursor-pointer'"
              @click.stop="
                checkValueFormat(item) === 'null' ? '' : clickValueItem(item, 'popVisible')
              "
            >
              {{ item.fieldDesc.showValueString }}
              <i class="el-icon-edit"></i>
            </span>

            <el-select
              v-else-if="item.selectField.refType === 'DICT'"
              v-model="item.selectValue"
              :multiple="checkValueFormat(item) === 'mulit'"
              :disabled="checkValueFormat(item) === 'null'"
              class="w-full"
              placeholder="请选择"
              @change="
                value => {
                  changeDictValue(value, item);
                }
              "
            >
              <el-option
                v-for="item1 in item.selectField.dictArray"
                :key="item1.dictValue"
                :label="item1.dictLabel"
                :value="item1.dictValue"
              />
            </el-select>
            <span
              v-else-if="item.selectField.refType === 'USER'"
              :class="checkValueFormat(item) === 'null' ? 'cursor-not-allowed' : 'cursor-pointer'"
              @click.stop="
                checkValueFormat(item) === 'null' ? '' : clickValueItem(item, 'metaUserDialog')
              "
            >
              {{ item.fieldDesc.showValueString }}
              <i class="el-icon-edit"></i>
            </span>

            <span
              v-else-if="item.selectField.refType === 'ORG'"
              :class="checkValueFormat(item) === 'null' ? 'cursor-not-allowed' : 'cursor-pointer'"
              @click.stop="
                checkValueFormat(item) === 'null' ? '' : clickValueItem(item, 'metaOrgDialog')
              "
            >
              {{ item.fieldDesc.showValueString }}
              <i class="el-icon-edit"></i>
            </span>
            <span v-else class="cursor-not-allowed"><i class="el-icon-edit"></i></span>
          </template>

          <!-- 左括号 -->
          <template #bracketLeft="{ item }">
            <el-select v-model="item.bracketLeft" class="w-full" placeholder="请选择">
              <el-option
                v-for="item1 in bracketLeftArray"
                :key="item1.value"
                :label="item1.label"
                :value="item1.value"
              />
            </el-select>
          </template>

          <!-- 右括号 -->
          <template #bracketRight="{ item }">
            <el-select v-model="item.bracketRight" class="w-full" placeholder="请选择">
              <el-option
                v-for="item1 in bracketRightArray"
                :key="item1.value"
                :label="item1.label"
                :value="item1.value"
              />
            </el-select>
          </template>

          <!-- 连接符 -->
          <template #connector="{ item }">
            <el-select v-model="item.connector" class="w-full" placeholder="请选择" clearable>
              <el-option
                v-for="item1 in connectorArray"
                :key="item1.value"
                :label="item1.label"
                :value="item1.value"
              />
            </el-select>
          </template>

          <!-- 操作 -->
          <template #operation="{ scope }">
            <i
              class="fn18 el-icon-remove pr-1"
              :class="tableFormParam.tableData.length > 1 ? 'el-icon-remove--hover' : ''"
              @click="tableFormParam.tableData.length > 1 ? removeItem(scope) : ''"
            ></i>
            <i
              class="fn18 el-icon-circle-plus el-icon-circle-plus--hover pr-1"
              @click="addItem(scope)"
            ></i>
            <i
              class="fn18 el-icon-bottom el-icon-circle-plus--hover pr-1"
              @click="downItem(scope)"
            ></i>
            <i class="fn18 el-icon-top el-icon-circle-plus--hover" @click="upItem(scope)"></i>
          </template>
        </general-table>
        <!-- </el-form> -->
      </div>
      <div v-else>
        <el-input v-model="customExpression" type="textarea" :rows="20"></el-input>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button plain @click="dialogVisible = false">取消</el-button>
        <el-button
          type="primary"
          :loading.sync="saving"
          :disabled="customRules ? !customExpression : tableFormParam.tableData.length === 0"
          @click="saveAction"
        >
          保存
        </el-button>
      </div>
      <metaQuery
        v-if="popVisible"
        :visible.sync="popVisible"
        :struct-code="selectItem ? selectItem.selectField.refCode : null"
        :multi="selectItem ? checkValueFormat(selectItem) === 'mulit' : false"
        class="h100"
        :default-selection="selectItem.selectValue"
        :value-key="selectItem.selectField.refField"
        :is-tree="selectedStruct.cursive"
        @valueChange="valueChange"
      />
    </el-dialog>
    <meta-user-dialog
      :visible.sync="metaUserDialog"
      :select-item-rule="selectItem"
      :multi="selectItem ? checkValueFormat(selectItem) === 'mulit' : false"
      width="1350px"
      top="5vh"
      @changeRuleValue="changeRuleValue"
    />
    <meta-org-dialog
      :visible.sync="metaOrgDialog"
      :select-item-rule="selectItem"
      :multi="selectItem ? checkValueFormat(selectItem) === 'mulit' : false"
      width="700px"
      top="5vh"
      @changeRuleValue="changeRuleValue"
    />
  </div>
</template>

<script>
import dataApi from "@/api/data-permission/dataPermission";
import { getDictionary } from "@/api/common";
import metaQuery from "./permission-data-meta-query.vue";
import MetaUserDialog from "./meta-user-dialog";
import MetaOrgDialog from "./meta-org-dialog";

export default {
  name: "DataMeta",
  components: {
    metaQuery,
    MetaUserDialog,
    MetaOrgDialog
  },
  props: {
    visible: {
      type: Boolean,
      default: () => false
    },
    type: {
      type: String,
      default: () => "add"
    },
    targetId: {
      type: String,
      default() {
        return "";
      }
    },
    targetType: {
      type: String,
      default() {
        return "2";
      }
    },
    resourceId: {
      type: String,
      default() {
        return "";
      }
    },
    defaultData: {
      type: Object,
      default() {
        return null;
      }
    }
  },
  data() {
    return {
      loading: false,
      tableHeaders: [
        {
          label: "左括号",
          key: "bracketLeft",
          width: "120",
          hidden: false,
          fixed: false
        },
        {
          label: "字段",
          key: "code",
          hidden: false,
          fixed: false
        },
        {
          label: "条件",
          key: "operators",
          hidden: false
        },
        {
          label: "值",
          key: "value",
          hidden: false
        },
        {
          label: "右括号",
          key: "bracketRight",
          width: "120",
          hidden: false
        },
        {
          label: "连接符",
          key: "connector",
          width: "120",
          hidden: false
        }
      ],
      solution: {
        planName: null,
        structCode: null
      },
      rules: {
        planName: [{ required: true, message: "请输入方案名称", trigger: "change" }],
        structCode: [{ required: true, message: "请选择业务对象", trigger: "change" }]
      },
      tableFormParam: { tableData: [] },
      selectedStruct: {},
      selectedItemCode: "",
      metadata: {},
      metadataDetail: {},
      popVisible: false,
      deleteDialogVisible: false,
      deleteLoading: false,
      deleteContent: {
        title: "删除数据",
        description: "你确认删除选中的数据吗"
      },
      selectItem: undefined,
      saving: false,
      metaUserDialog: false,
      metaOrgDialog: false,
      customRules: false,
      customExpression: "",
      reload: true
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      }
    },
    dialogLoading: {
      get() {
        return this.loading;
      },
      set(val) {
        this.$emit("update:loading", val);
      }
    },
    operatorsObject() {
      const object = {
        EQ: "等于",
        NE: "不等于",
        GE: "大于等于",
        GT: "大于",
        LE: "小于等于",
        LT: "小于",
        IN: "包含",
        NOT_IN: "不包含",
        LIKE: "模糊匹配",
        LIKE_START: "前模糊匹配",
        LIKE_END: "后模糊匹配",
        IS_NULL: "为空",
        NOT_NULL: "非空",
        CURRENT_USER: "当前用户",
        NON_CURRENT_USER: "非当前用户",
        CURRENT_ORG: "本级组织",
        CURRENT_CHILD_ORG: "本级及子级组织"
      };
      return object;
    },
    bracketLeftArray() {
      const array = [
        { label: "无", value: "L0" },
        { label: "(", value: "L1" },
        { label: "((", value: "L2" },
        { label: "(((", value: "L3" }
      ];
      return array;
    },
    bracketRightArray() {
      const array = [
        { label: "无", value: "R0" },
        { label: ")", value: "R1" },
        { label: "))", value: "R2" },
        { label: ")))", value: "R3" }
      ];
      return array;
    },
    connectorArray() {
      const array = [
        { label: "且", value: "AND" },
        { label: "或", value: "OR" }
      ];
      return array;
    }
  },
  watch: {
    defaultData: {
      deep: true,
      immediate: true,
      handler(data) {
        this.reload = false;

        this.$nextTick(() => {
          this.reload = true;
        });
        const { customRules = false, expression } = data.dataRules || {};
        this.customRules = customRules;
        this.customExpression = expression;
        this.initData();
      }
    }
  },
  mounted() {
    this.getMetadataStruct();
  },
  methods: {
    initData() {
      if (this.defaultData) {
        const data = JSON.parse(JSON.stringify(this.defaultData));
        this.solution.planName = data.dataRules.ruleName;
        this.solution.structCode = data.dataRules.bizCode;
        const item = this.metadataDetail[this.solution.structCode];
        if (item) {
          this.selectedStruct = item;
          this.initTableData(data);
        } else {
          dataApi
            .getMetadataStructByCode(this.solution.structCode)
            .then(res => {
              if (res && res.data) {
                this.metadataDetail[this.solution.structCode] = res.data;
                this.selectedStruct = res.data;
                this.initTableData(data);
              }
            })
            .catch(() => {});
        }
      }
    },

    initTableData(data) {
      if (data) {
        this.tableFormParam = { tableData: [] };
        // this.tableFormParam.tableData = data.dataRules.rules;
        data.dataRules.rules.forEach((item, index) => {
          // this.addTableItem(index);
          // this.tableFormParam.tableData.push(item);
          this.addTableItem(index);
          const tableItem = this.tableFormParam.tableData[index];
          tableItem.selectValue = [];
          tableItem.connector = "";
          for (const key in item) {
            tableItem[key] = item[key];
          }
        });
        this.$nextTick(() => {
          this.tableFormParam.tableData.forEach(item => {
            item.fieldDesc = item.fieldDesc ? item.fieldDesc : { showValueString: "" };
            this.selectedStruct.fields.forEach(element => {
              if (item.field === element.fieldCode) {
                item.selectField = element;
                // item.operator = '';
                item.operatorArray = this.handleOperators(element.operators);
                if (this.checkValueFormat(item) === "mulit") {
                  item.selectValue = [];
                  if (item.value) {
                    item.selectValue = item.value.split(",");
                  }
                } else {
                  item.selectValue = item.value;
                }
                if (item.selectField.refType === "DICT") {
                  this.$set(item.selectField, "dictArray", []);
                  this.getCodeType(item.selectField);
                }
              }
            });
          });
        });
      }
    },

    // 获取码段类型字典
    async getCodeType(field) {
      const res = await getDictionary({ code: field.refCode });
      if (res.success) {
        if (res.data && res.data.dictItems && res.data.dictItems.length) {
          field.dictArray = res.data.dictItems;
        }
      }
      // getDictionary({ code: field.refCode }).then(res => {
      //   if (res.success) {
      //     if (res.data && res.data.dictItems && res.data.dictItems.length) {
      //       field.dictArray = res.data.dictItems;
      //     }
      //   }
      // });
    },
    /**
     * @description: 查询租户下元数据结构
     * @param {*}
     * @return {*}
     */
    getMetadataStruct() {
      dataApi
        .getMetadataStruct()
        .then(res => {
          if (res && res.success) {
            this.metadata = res.data;
            this.initData();
          }
        })
        .catch(() => {});
    },
    /**
     * @description:
     * @param {*} value
     * @return {*}
     */
    changeStruct(value) {
      this.tableFormParam.tableData = [];
      const item = this.metadataDetail[value];
      if (item) {
        this.selectedStruct = item;
        this.addTableItem(0);
      } else {
        dataApi
          .getMetadataStructByCode(value)
          .then(res => {
            if (res && res.data) {
              this.metadataDetail[value] = res.data;
              this.selectedStruct = res.data;
              this.addTableItem(0);
            }
          })
          .catch(() => {});
      }
    },
    /**
     * @description:
     * @param {*} visible
     * @return {*}
     */
    structVisibleChange(visible) {
      if (visible && this.solution.structCode !== null) {
        this.$message.warning("更改业务对象会清空已填写的规则列表，请谨慎操作！");
      }
    },
    /**
     * @description: 值是字典的时候，选择变化
     * @param {*}
     * @return {*}
     */
    changeDictValue(val, item) {
      if (val) {
        let value = "";
        if (Array.isArray(val)) {
          val.forEach((element, index) => {
            if (index > 0) {
              value = `${value},`;
            }
            value = value + element;
          });
        } else {
          value = val;
        }

        item.value = value;
      }
    },
    /**
     * @description:
     * @param {*} index
     * @return {*}
     */
    addTableItem(index) {
      const item = {
        selectField: {},
        selectValue: [],
        field: "",
        operator: "",
        fieldDesc: {
          showValueString: ""
        },
        value: "",
        connector: "",
        bracketLeft: "L0",
        bracketRight: "R0"
      };
      if (index < this.tableFormParam.tableData.length) {
        this.tableFormParam.tableData.splice(index, 0, item);
      } else {
        this.tableFormParam.tableData.push(item);
      }
    },
    /**
     * @description: 选择字段
     * @param {*} value
     * @param {*} item
     * @return {*}
     */
    changeCodeSource(value, item) {
      this.selectedStruct.fields.forEach(element => {
        if (value === element.fieldCode) {
          item.selectField = element;
          item.operator = "";
          item.fieldDesc.showValueString = "";
          item.selectValue = [];
          item.dictArray = [];
          item.value = "";
          item.bracketLeft = "L0";
          item.bracketRight = "R0";
          item.operatorArray = this.handleOperators(element.operators);
          if (item.selectField.refType === "DICT") {
            this.getCodeType(item.selectField);
          }
        }
      });
    },
    /**
     * @description: 格式化条件
     * @param {*} operators
     * @return {*}
     */
    handleOperators(operators) {
      const array = [];
      operators.forEach(element => {
        const label = this.operatorsObject[element];
        array.push({
          label,
          value: element
        });
      });
      return array;
    },
    /**
     * @description: 选择条件
     * @param {*} value
     * @param {*} item
     * @return {*}
     */
    changeOperatorSource(value, item) {
      item.fieldDesc.showValueString = "";
      item.selectValue = [];
      item.value = "";
    },
    /**
     * @description: 保存
     * @param {*}
     * @return {*}
     */
    saveAction() {
      // this.$refs.tableForm.validate(valid => {})
      this.$refs.planForm.validate(valid => {
        if (valid) {
          let type = "ROLE";
          switch (this.targetType) {
            case "1":
              type = "DEPT";
              break;
            case "2":
              type = "ROLE";
              break;
            case "3":
              type = "USER";
              break;

            default:
              break;
          }
          let data = {
            targetType: type,
            targetId: this.targetId,
            resourceId: this.resourceId
          };
          const dataRules = {
            ruleType: "SQL",
            ruleName: this.solution.planName,
            bizCode: this.solution.structCode
          };
          if (this.defaultData) {
            data = this.defaultData;
            dataRules.id = this.defaultData.dataRules.id;
          }

          const rules = [];
          this.tableFormParam.tableData.forEach(element => {
            if (element.field && element.field !== "") {
              const item = {
                bracketLeft: element.bracketLeft,
                bracketRight: element.bracketRight,
                operator: element.operator,
                field: element.field,
                value: element.value,
                fieldDesc: element.fieldDesc
              };
              if (element.connector !== "") {
                item.connector = element.connector;
              }
              rules.push(item);
            }
          });
          if (!this.customRules && rules.length) {
            dataRules.rules = rules;
            data.dataRules = dataRules;
            this.saving = true;

            dataApi
              .saveCustomResource(data)
              .then(res => {
                this.saving = false;

                if (res && res.success) {
                  this.$message({
                    type: "success",
                    message: "保存成功!"
                  });
                  this.$emit("dataMetaChange");
                  this.dialogVisible = false;
                } else {
                  this.$message.error("保存失败");
                }
              })
              .catch(() => {
                this.saving = false;
              });
          }

          if (this.customRules && this.customExpression) {
            dataRules.expression = this.customExpression;
            data.dataRules = dataRules;
            this.saving = true;

            dataApi
              .saveCustomResource(data)
              .then(res => {
                this.saving = false;

                if (res && res.success) {
                  this.$message({
                    type: "success",
                    message: "保存成功!"
                  });
                  this.$emit("dataMetaChange");
                  this.dialogVisible = false;
                } else {
                  this.$message.error("保存失败");
                }
              })
              .catch(() => {
                this.saving = false;
              });
          }
        }
      });
    },
    /**
     * @description: 点击值
     * @param {*} item
     * @return {*}
     */
    clickValueItem(item, dialogVisible) {
      this.selectItem = item;
      this[dialogVisible] = true;
    },
    /**
     * @description:
     * @param {*} item
     * @return {*}
     */
    removeItem(item) {
      this.tableFormParam.tableData.splice(item.$index, 1);
    },
    /**
     * @description:
     * @param {*} item
     * @return {*}
     */
    addItem(item) {
      this.addTableItem(item.$index + 1);
    },
    /**
     * @description:
     * @param {*} item
     * @return {*}
     */
    upItem(item) {
      if (this.tableFormParam.tableData.length < 2) {
        return;
      }
      if (item.$index === 0) {
        this.tableFormParam.tableData.push(this.tableFormParam.tableData[0]);
        this.tableFormParam.tableData.splice(0, 1);
      } else {
        this.tableFormParam.tableData.splice(
          item.$index - 1,
          1,
          ...this.tableFormParam.tableData.splice(
            item.$index,
            1,
            this.tableFormParam.tableData[item.$index - 1]
          )
        );
      }
    },
    /**
     * @description:数据的要求，null(不需要填写)，single(单选)，mulit(多选)
     * @param {*}
     * @return {*}
     */
    checkValueFormat(item) {
      if (item.operator === "") {
        return "null";
      }
      let disabled = "null";
      switch (item.operator) {
        case "":
        case "IS_NULL":
        case "NOT_NULL":
        case "CURRENT_USER":
        case "NON_CURRENT_USER":
        case "CURRENT_ORG":
        case "CURRENT_CHILD_ORG":
          disabled = "null";
          break;
        case "IN":
        case "NOT_IN":
          disabled = "mulit";
          break;
        default:
          disabled = "single";
          break;
      }
      return disabled;
      // EQ: '等于',
      // NE: '不等于',
      // GE: '大于等于',
      // GT: '大于',
      // LE: '小于等于',
      // LT: '小于',
      // IN: '包含',
      // NOT_IN: '不包含',
      // LIKE: '模糊匹配',
      // LIKE_START: '前模糊匹配',
      // LIKE_END: '后模糊匹配',
      // IS_NULL: '为空',
      // NOT_NULL: '非空',
      // CURRENT_USER: '当前用户',
      // NON_CURRENT_USER: '非当前用户',
      // CURRENT_ORG: '本级组织',
      // CURRENT_CHILD_ORG: '本级及子级组织'
    },
    /**
     * @description:
     * @param {*} item
     * @return {*}
     */
    downItem(item) {
      if (this.tableFormParam.tableData.length < 2) {
        return;
      }
      if (item.$index === this.tableFormParam.tableData.length - 1) {
        this.tableFormParam.tableData.splice(0, 0, this.tableFormParam.tableData[item.$index]);
        this.tableFormParam.tableData.splice(item.$index + 1, 1);
      } else {
        this.tableFormParam.tableData.splice(
          item.$index + 1,
          1,
          ...this.tableFormParam.tableData.splice(
            item.$index,
            1,
            this.tableFormParam.tableData[item.$index + 1]
          )
        );
      }
    },
    // 修改规则的值
    changeRuleValue({ value, showValueString }) {
      this.selectItem.value = value;
      this.selectItem.fieldDesc.showValueString = showValueString;
    },
    /**
     * @description:
     * @param {*} valueArray
     * @return {*}
     */
    valueChange(valueArray) {
      this.selectItem.valueArray = valueArray;
      this.handleShowValue(this.selectItem);
    },
    /**
     * @description: 处理展示的值
     * @param {*} item
     * @return {*}
     */
    handleShowValue(item) {
      let string = "";
      let value = "";
      item.selectValue = [];
      if (item.valueArray) {
        item.valueArray.forEach((element, index) => {
          if (index > 0) {
            string = `${string},`;
            value = `${value},`;
          }
          string = string + element.showValue;
          value = value + element[item.selectField.refField];
          item.selectValue.push(element[item.selectField.refField]);
        });
      }
      item.fieldDesc.showValueString = string;
      item.value = value;
    }
  }
};
</script>

<style lang="scss" scop>
.el-icon-remove {
  color: #c6ccd7;
  font-size: 18px !important;

  &:disabled {
    color: gray;
  }
}

.el-icon-remove--hover {
  cursor: pointer;
  color: #e60100;
  &:hover {
    color: #e60100;
  }
}

.el-icon-circle-plus {
  color: #00b259;
  font-size: 18px !important;
}

.el-icon-circle-plus--hover {
  cursor: pointer;

  &:hover {
    color: #008f3d;
  }
}
</style>
